import type { AdminViewDefinition } from "../../components/admin-components.js";

export const domainAdminViews: AdminViewDefinition[] = [
  domainHealthListView(),
  globalCompetitorsView(),
  domainHealthDetailView(),
];

function domainHealthListView(): AdminViewDefinition {
  return {
    id: "domain-health-list",
    navId: "domains",
    title: "Competitor Domain Health",
    description:
      "Monitor extraction reliability, field completeness, access blocks, and merchant impact by domain.",
    actions: [
      {
        label: "Run domain diagnostic",
        routeId: "run-domain-diagnostic",
        disabled: true,
        disabledReason: "Use the Extraction Diagnostics page until this overlay is wired.",
      },
    ],
  };
}

function domainHealthDetailView(): AdminViewDefinition {
  return {
    id: "domain-health-detail",
    navId: "domains",
    title: "Domain Health Detail",
    description: "Live competitor-domain health and extraction control state.",
    actions: [
      {
        label: "Test another URL",
        routeId: "run-domain-diagnostic",
        disabled: true,
        disabledReason: "Use the Extraction Diagnostics page until this overlay is wired.",
      },
      {
        label: "Change status",
        variant: "primary",
        routeId: "change-domain-status",
        disabled: true,
        disabledReason: "Use the live form on this detail page.",
      },
    ],
  };
}

function globalCompetitorsView(): AdminViewDefinition {
  return {
    id: "global-competitors",
    navId: "global-competitors",
    title: "Global Competitors",
    description: "Manage system-wide requested-site support overrides.",
  };
}
